import { SMILE9_API_ENDPOINT } from './../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthenticateService } from '../share/authenticate/authenticate.service';
import { UtilService } from '../share/util/util.service';
import { IAutoAct } from './auto-act-if';
import { CheckNullExpectType } from '../share/enums-master';

@Injectable()
export class AutoActService {
  controlerName = 'api/AutoAct';
  subHttpClients = new Subscription();

  constructor(
    public http: HttpClient,
    public utilServ: UtilService,
    public authServ: AuthenticateService,
  ) { }

  public getAutoActInfo(model: IAutoAct.GetAutoActInfo): Promise<IAutoAct.AutoActInfo> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams({ fromObject: {
        smile9Id: this.utilServ.uType.checkNull(model.smile9Id, CheckNullExpectType.string),
        ug_id: this.utilServ.uType.checkNull(model.ug_id, CheckNullExpectType.string),
      }});
      this.subHttpClients.add(
        this.http.get(SMILE9_API_ENDPOINT + `${this.controlerName}/AutoActInfo`, {params: params}).subscribe(
          res => resolve(res as IAutoAct.AutoActInfo),
          error => reject(error)
        )
      );
    });
  }

  public postBrowserLogs(model: IAutoAct.BrowserLogs): Promise<IAutoAct.PostBrowserLogsResult> {
    return new Promise((resolve, reject) => {
      Object.assign(model, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('post', SMILE9_API_ENDPOINT + `${this.controlerName}/BrowserLogs`, { body: model }).subscribe(
          res => resolve(res as IAutoAct.PostBrowserLogsResult),
          error => reject(error)
        )
      );
    });
  }

  public checkItadakimasuOpe(model: IAutoAct.CheckItadakimasuOpe): Promise<IAutoAct.CheckItadakimasuOpeResult> {
    return new Promise((resolve, reject) => {
      Object.assign(model, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('put', SMILE9_API_ENDPOINT + `${this.controlerName}/Action`, { body: model }).subscribe(
          res => resolve(res as IAutoAct.CheckItadakimasuOpeResult),
          error => reject(error)
        )
      );
    });
  }
}
